import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStyledAlertListRow } from 'types/ui/alertListRow.interface'

export const AlertList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Row = styled.div<IStyledAlertListRow>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  ${(props) => props.$clickable && 'cursor: pointer;'}

  &:last-child {
    border-bottom: none;
  }
`

export const RowText = styled.div`
  flex: 1;
  min-width: 0;
`

export const RowTitle = styled.div`
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
`

export const RowMeta = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const PillHit = styled.button`
  display: inline-flex;
  align-items: center;
  flex: none;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`
